"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

function jsonTryParse(value) {
  var response = {
    value: value,
    isValid: true
  };
  value = typeof value !== 'string' ? JSON.stringify(value) : value;

  try {
    value = JSON.parse(value);
  } catch (e) {
    response.isValid = false;
  }

  if (response.isValid) {
    if (typeof value === 'object' && value !== null) {
      response.value = value;
      response.isValid = true;
    } else {
      response.isValid = false;
    }
  }

  return response;
}

exports.jsonTryParse = jsonTryParse;